document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.fcb-accordion');
  const summaries = document.querySelectorAll('.fcb-accordion > summary');

  if (summaries.length === 0) return;

  summaries.forEach((summary, index) => {
    summary.addEventListener('keydown', (e) => {
      
      if (e.key === 'Escape') {
        e.preventDefault(); 
        const activeTab = document.querySelector('.tablinks.active');
        if (activeTab) {
          activeTab.focus(); 
        }
        return; 
      }

      let nextIndex = index;
      let shouldPreventDefault = true;

      if (e.key === 'ArrowDown') {
        nextIndex = (index + 1) % summaries.length;
      } else if (e.key === 'ArrowUp') {
        nextIndex = (index - 1 + summaries.length) % summaries.length;
      } else if (e.key === 'Home') {
        nextIndex = 0;
      } else if (e.key === 'End') {
        nextIndex = summaries.length - 1;
      } else {
        shouldPreventDefault = false;
      }

      if (shouldPreventDefault) {
        e.preventDefault();
        summaries[nextIndex].focus();
      }
    });

    summary.parentElement.addEventListener('toggle', (event) => {
        if (event.target.open) {
            accordions.forEach(acc => {
                if (acc !== event.target) {
                    acc.open = false;
                }
            });
        }
    });
  });
});